var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('td',{class:{ 'text-end': _vm.right },attrs:{"nowrap":_vm.nowrap}},[_vm._t("default"),(!this.$slots.default)?_c('span',[_vm._v("--")]):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }